export default __webpack_public_path__ + "static/Blitz6 01F358C3-0e381240e4c0a646844ee79aa99d65f7.jpg";